export default __webpack_public_path__ + "static/media/openIMIS.a66cf925.png";